import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";

import { CreateAccountForm } from "../../forms";
import { CreateProfileFormTypeV2 } from "../../../../services/user-create/user-create.schema";
import { LayoutOnboarding } from "../../../../components";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import { PAGES_PATH } from "../../../../navigation/params";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useOtpSignUp } from "../../../../services/user/user-otp.service";
import { useUserStatusStore } from "../../../../hooks/redux-hooks/user-status/user-status.store";
import { userActions } from "../../../../state/user";
import { userActivityLogger } from "../../../../utils/mixpanel";

const CreateProfileContainer = () => {
  const { setEmailSignIn, setPhoneSignIn } = useUserStatusStore();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sendOTP, data } = useOtpSignUp();

  const handleSubmit = (data: CreateProfileFormTypeV2) => {
    localStorage.setItem("signUp", "true");
    dispatch(userActions.setEmailSignIn(data.email));
    sendOTP({ email: data.email });
    userActivityLogger(MIXPANEL_EVENTS.USER_REQUEST_OTP,
      { signin_type: "email", user_type: "new_user" },
      { email: data.email });
  };

  useEffect(() => {
    setEmailSignIn("");
    setPhoneSignIn("");
  }, []);

  useEffect(() => {
    if (data?.success) {
      navigate(PAGES_PATH.OTP_VERIFICATION);
    }
  }, [data]);

  return (
    <LayoutOnboarding image="/assets/icons/welcome_screen.jpg">
      <Box className="flex flex-col items-center w-full h-full gap-4">
        <Typography variant="h1" className="!font-bold">Create Account</Typography>
        <Typography sx={{ mb: 1 }} className="flex !text-base">
          Already have an account?
          <span
            className="!ms-2 text-mustard !text-base cursor-pointer font-semibold"
            onClick={()=>navigate(`${PAGES_PATH.SIGN_IN}`)}
          >
            Log In
          </span>
        </Typography>
        <CreateAccountForm onSubmit={handleSubmit} hideTerms={false} />
      </Box>
    </LayoutOnboarding>
  );
};

export default CreateProfileContainer;
